import React from 'react';
import ReportList from './components/ReportList';
import ReportCreate from './components/ReportCreate';
import { useState } from 'react';

const ReportsPage: React.FC = () => {
    const [archive, setArchive] = useState(false);
    const switchTab = (nextArchive: boolean) => {
        setArchive(nextArchive);
    };
    return (
        <div>
            <div className="flex mx-5 items-start gap-4">
                <ReportCreate />
                <ReportList />
            </div>
        </div>
    );
};

export default ReportsPage;



